import React from "react";
import * as Icons from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { Counter } from "../components/site/Counter";
import { TechLines } from "../components/site/TechLines";
import { WHY, STATS } from "../data/content";

export const WhyUs = () => (
  <section id="why" className="relative overflow-hidden bg-emerald-darkest py-24 text-off-white sm:py-32" data-testid="why-section">
    <TechLines className="opacity-40" />
    <div className="grain absolute inset-0" />
    <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-2xl">
        <Reveal><Overline dark>Why OnwardTranscends</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif text-4xl font-light leading-tight sm:text-5xl">
            Strategy meets <span className="text-gradient-gold">hands-on delivery</span>.
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-6 border-y border-white/10 py-12 sm:grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div data-testid={`stat-${i}`}>
              <p className="font-serif text-5xl text-gradient-gold sm:text-6xl">
                <Counter value={s.value} suffix={s.suffix} />
              </p>
              <p className="mt-2 text-sm text-off-white/60">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {WHY.map((w, i) => {
          const Icon = Icons[w.icon] || Icons.Sparkles;
          return (
            <Reveal key={w.title} delay={i * 0.08}>
              <div data-testid={`why-card-${i}`} className="glass h-full rounded-2xl p-7 transition-transform duration-500 hover:-translate-y-1.5">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-base/60 text-gold-light">
                  <Icon size={22} />
                </div>
                <h3 className="mt-5 font-serif text-2xl">{w.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-off-white/65">{w.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
